/**
 * Generated by orval v8.18.0 🍺
 * Do not edit manually.
 * SurveyHealth.Consent.Api | v1
 * OpenAPI spec version: 1.0.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import { consentApiClient } from '../lib/apiClient';
export interface ConsentLinkResult {
  clinicName: string;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  consentVersion: number | string;
  body: string;
  consentCheckboxText: string;
  videoReference: string;
}

export interface VerifyDobRequest {
  dateOfBirth: string;
}

export interface VerifyDobResult {
  patientName: string;
  verificationToken: string;
}

export interface SubmitConsentRequest {
  verificationToken: string;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  consentVersion: number | string;
  accepted: boolean;
}

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getGetConsentLinkUrl = (token: string,) => {




  return `/v1/public/${token}`
}

export const getConsentLink = async (token: string, options?: RequestInit): Promise<ConsentLinkResult> => {

  return consentApiClient<ConsentLinkResult>(getGetConsentLinkUrl(token),
  {
    ...options,
    method: 'GET'


  }
);}




export const getGetConsentLinkMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getConsentLink>>, TError,{token: string}, TContext>, request?: SecondParameter<typeof consentApiClient>}
): UseMutationOptions<Awaited<ReturnType<typeof getConsentLink>>, TError,{token: string}, TContext> => {

const mutationKey = ['getConsentLink'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof getConsentLink>>, {token: string}> = (props) => {
          const {token} = props ?? {};

          return  getConsentLink(token,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GetConsentLinkMutationResult = NonNullable<Awaited<ReturnType<typeof getConsentLink>>>

    export type GetConsentLinkMutationError = unknown

    export const useGetConsentLink = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getConsentLink>>, TError,{token: string}, TContext>, request?: SecondParameter<typeof consentApiClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof getConsentLink>>,
        TError,
        {token: string},
        TContext
      > => {
      return useMutation(getGetConsentLinkMutationOptions(options), queryClient);
    }

export const getVerifyDobUrl = (token: string,) => {




  return `/v1/public/${token}/verify-dob`
}

export const verifyDob = async (token: string,
    verifyDobRequest: VerifyDobRequest, options?: RequestInit): Promise<VerifyDobResult> => {

  return consentApiClient<VerifyDobResult>(getVerifyDobUrl(token),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(verifyDobRequest)
  }
);}





export const getVerifyDobQueryKey = (token: string,
    verifyDobRequest?: VerifyDobRequest,) => {
    return [
    'POST', `/v1/public/${token}/verify-dob`, verifyDobRequest
    ] as const;
    }


export const getVerifyDobQueryOptions = <TData = Awaited<ReturnType<typeof verifyDob>>, TError = unknown>(token: string,
    verifyDobRequest: VerifyDobRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof verifyDob>>, TError, TData>>, request?: SecondParameter<typeof consentApiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getVerifyDobQueryKey(token,verifyDobRequest);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof verifyDob>>> = ({ signal }) => verifyDob(token,verifyDobRequest, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: token !== null && token !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof verifyDob>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type VerifyDobQueryResult = NonNullable<Awaited<ReturnType<typeof verifyDob>>>
export type VerifyDobQueryError = unknown


export function useVerifyDob<TData = Awaited<ReturnType<typeof verifyDob>>, TError = unknown>(
 token: string,
    verifyDobRequest: VerifyDobRequest, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof verifyDob>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof verifyDob>>,
          TError,
          Awaited<ReturnType<typeof verifyDob>>
        > , 'initialData'
      >, request?: SecondParameter<typeof consentApiClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useVerifyDob<TData = Awaited<ReturnType<typeof verifyDob>>, TError = unknown>(
 token: string,
    verifyDobRequest: VerifyDobRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof verifyDob>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof verifyDob>>,
          TError,
          Awaited<ReturnType<typeof verifyDob>>
        > , 'initialData'
      >, request?: SecondParameter<typeof consentApiClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useVerifyDob<TData = Awaited<ReturnType<typeof verifyDob>>, TError = unknown>(
 token: string,
    verifyDobRequest: VerifyDobRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof verifyDob>>, TError, TData>>, request?: SecondParameter<typeof consentApiClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useVerifyDob<TData = Awaited<ReturnType<typeof verifyDob>>, TError = unknown>(
 token: string,
    verifyDobRequest: VerifyDobRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof verifyDob>>, TError, TData>>, request?: SecondParameter<typeof consentApiClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getVerifyDobQueryOptions(token,verifyDobRequest,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getSubmitConsentUrl = (token: string,) => {




  return `/v1/public/${token}/consent`
}

export const submitConsent = async (token: string,
    submitConsentRequest: SubmitConsentRequest, options?: RequestInit): Promise<void> => {

  return consentApiClient<void>(getSubmitConsentUrl(token),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(submitConsentRequest)
  }
);}





export const getSubmitConsentQueryKey = (token: string,
    submitConsentRequest?: SubmitConsentRequest,) => {
    return [
    'POST', `/v1/public/${token}/consent`, submitConsentRequest
    ] as const;
    }


export const getSubmitConsentQueryOptions = <TData = Awaited<ReturnType<typeof submitConsent>>, TError = unknown>(token: string,
    submitConsentRequest: SubmitConsentRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof submitConsent>>, TError, TData>>, request?: SecondParameter<typeof consentApiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSubmitConsentQueryKey(token,submitConsentRequest);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof submitConsent>>> = ({ signal }) => submitConsent(token,submitConsentRequest, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: token !== null && token !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof submitConsent>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SubmitConsentQueryResult = NonNullable<Awaited<ReturnType<typeof submitConsent>>>
export type SubmitConsentQueryError = unknown


export function useSubmitConsent<TData = Awaited<ReturnType<typeof submitConsent>>, TError = unknown>(
 token: string,
    submitConsentRequest: SubmitConsentRequest, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof submitConsent>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof submitConsent>>,
          TError,
          Awaited<ReturnType<typeof submitConsent>>
        > , 'initialData'
      >, request?: SecondParameter<typeof consentApiClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSubmitConsent<TData = Awaited<ReturnType<typeof submitConsent>>, TError = unknown>(
 token: string,
    submitConsentRequest: SubmitConsentRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof submitConsent>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof submitConsent>>,
          TError,
          Awaited<ReturnType<typeof submitConsent>>
        > , 'initialData'
      >, request?: SecondParameter<typeof consentApiClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSubmitConsent<TData = Awaited<ReturnType<typeof submitConsent>>, TError = unknown>(
 token: string,
    submitConsentRequest: SubmitConsentRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof submitConsent>>, TError, TData>>, request?: SecondParameter<typeof consentApiClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useSubmitConsent<TData = Awaited<ReturnType<typeof submitConsent>>, TError = unknown>(
 token: string,
    submitConsentRequest: SubmitConsentRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof submitConsent>>, TError, TData>>, request?: SecondParameter<typeof consentApiClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSubmitConsentQueryOptions(token,submitConsentRequest,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}
